import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isCalendarEventLocalLie } from 'owa-calendar-event-local-lie';
import { isEventInstanceOfSeries } from 'owa-calendar-event-capabilities';

/**
 * Returns true if the form is in edit mode and the item being edited
 * is an instance of a series.
 * @param event: CalendarEvent
 */
export default function isInEditSeriesInstanceMode(event: CalendarEvent): boolean {
    return !isCalendarEventLocalLie(event) && isEventInstanceOfSeries(event);
}
